import { render, staticRenderFns } from "./ttshop_usernews.vue?vue&type=template&id=00278f51&scoped=true"
import script from "./ttshop_usernews.vue?vue&type=script&lang=js"
export * from "./ttshop_usernews.vue?vue&type=script&lang=js"
import style0 from "./ttshop_usernews.vue?vue&type=style&index=0&id=00278f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00278f51",
  null
  
)

export default component.exports